<div
    class="stat-item position-relative"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h5>
        {{ 'Total_Systems' | translate}}
    </h5>
    <div class="number lh-1 fw-medium">
        5
    </div>
    <span class="daxa-up-down-badge position-relative">
        <i class="material-symbols-outlined">
            trending_up
        </i>
        {{ '20.75' | cultural }}%
    </span>
    <div class="chart">
        <div id="crm_revenue_growth_chart"></div>
        <div class="title d-block text-body">
            {{ 'Weekly_Growth' | translate}}
        </div>
    </div>
</div>